import BaseComponent from '../BaseComponent';

const NAME = 'Stepper';

export default class Stepper extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element, config) {
		super(element);
		if (this._element) {
			this.classPrefix = config.classPrefix;
			this.stepTitle = config.stepTitle;
			this.totalStepCount = config.totalSteps;
			this.currentStepCount = config.currentStep;
			this.stepVisibility = config.stepVisibility;
		}
	}

	markup() {
		return `<div class="${this.classPrefix}__stepper">
      <div class="lta-steps u-mb-5 md:u-mb-8">
        <div class="l-grid__inner u-mb-1">
          <p class="
              l-grid__cell--span-4
              l-grid__cell--span-6-xs
              l-grid__cell--span-6-sm
              l-grid__cell--span-12-xl
              l-grid__cell--align-middle
              u-text-center
              lta-steps__title">
                ${this.stepTitle}
            </p>
          </div>
          <div
            class="lta-steps__wrapper"
            aria-role="progress"
            aria-label="step ${this.currentStepCount} of ${this.totalStepCount}"
          >
            ${this.stepItemsMarkup()}
          </div>
        </div>
      </div>
    </div>`;
	}

	stepItemsMarkup() {
		const stepElements = [];
		for (let index = 1; index <= this.totalStepCount; index++) {
			const completedClass = index <= this.currentStepCount ? 'lta-steps__item--complete' : '';
			let visibilityHiddenClass = '';
			if (this.stepVisibility?.length > 0) {
				visibilityHiddenClass = !this.stepVisibility[index - 1] ? 'lta-steps_visibility-hidden' : '';
			}
			const stepElement = `<div class="lta-steps__item lta-steps__item-${index} ${completedClass} ${visibilityHiddenClass}"></div>`;
			stepElements.push(stepElement);
		}
		return stepElements.join('');
	}
	updateState({ stepTitle, currentStepCount }) {
		this.stepTitle = stepTitle || this.stepTitle;
		this.currentStepCount = currentStepCount || this.currentStepCount;
	}
}
